String.prototype.hashCode = function() {
  var hash = 0, i, chr, len;
  if (this.length === 0) return hash;
  for (i = 0, len = this.length; i < len; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

function createGuid() {
  return randomString() + randomString() + '-' + randomString() + '-' + randomString() + '-' + randomString() + '-' + randomString() + randomString() + randomString();
}

function randomString() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function checkPassword(str)
{
  var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
  return re.test(str);
}

/**
* Function to evaluate the validity of a password
*/
function password_evaluator(new_password)
{
  var ucase = new RegExp("[A-Z]+");
  var lcase = new RegExp("[a-z]+");
  var num = new RegExp("[0-9]+");

  var at_least_6_char   = {'color': '#FF0004','icon' : 'glyphicon-remove','text' : "At least 6 Characters Long"};
  var at_least_1_ucase  = {'color': '#FF0004','icon' : 'glyphicon-remove','text' : "One Uppercase Letter"};
  var at_least_1_lcase  = {'color': '#FF0004','icon' : 'glyphicon-remove','text' : "One Lowercase Letter"};
  var at_least_1_num    = {'color': '#FF0004','icon' : 'glyphicon-remove','text' : "One Number"};

  if(new_password)
  {
    //Legth atleast 6 char
    if(new_password.length >= 6)
    {
      at_least_6_char.icon = 'glyphicon-ok';
      at_least_6_char.color = '#00A41E';
    }
    //Atleast 1 upper case char
    if(ucase.test(new_password)){
      at_least_1_ucase.icon = 'glyphicon-ok';
      at_least_1_ucase.color = '#00A41E';
    }
    //Atleast 1 lower case char
    if(lcase.test(new_password)){
      at_least_1_lcase.icon = 'glyphicon-ok';
      at_least_1_lcase.color = '#00A41E';
    }
    //Atleast 1 number
    if(num.test(new_password)){
      at_least_1_num.icon = 'glyphicon-ok';
      at_least_1_num.color = '#00A41E';
    }    
  }

  //response data
  evaluation_response = [at_least_6_char, at_least_1_ucase, at_least_1_lcase, at_least_1_num];

  return evaluation_response;
}
